const { isEmptyObject } = require("jquery");
window.$ = window.jQuery = require("jquery");

$(document).ready(function () {
    $('#year-select-order').on('change',function(){
        let year = $(this).val();
        let userId = $(this).data('user_id');
        let formData = new FormData();
        formData.append("year-select",year);
        formData.append("user_id",userId);

        if(year){
            $.ajax({
                url: mm_wc_apiurl.order_year,
                type: "post",
                data: formData,
                contentType: false,
                processData: false,
                async: false,
                dataType: "json",
                success: function (d) {
                 $ta_template = d;
                    $('.woocommerce-orders-table').replaceWith($ta_template);
                },
            }); 
        }else{
            $('#order-select').html('<option value="">Select year first</option>'); 
        }
    });
});
  